import { SectionSwitcher } from "../jobs-flow/SectionSwitcher";

export default {
    syncCheckerInterval: null,

    init() {
        this.initSections();
        this.initHelpIcons();
        this.initSaveButton();
        this.initDisconnectButton();
        this.initShowErrors();
        this.initStartFullSync();
        this.initManualSyncRange();
        this.initReloadPreloader();
        this.initSettingClicksChecker();
        this.initContactUpButton();
    },

    initSections() {
        if (
            window.location.pathname === '/quickbooks-integration'
            || window.location.pathname === "/admin/organization-management/quickbooks-sync-list"
        ) {
            this.sectionSwitcher = SectionSwitcher.start(false);

            if (window.location.search.includes('quickbooks-settings')) {
                $('.section.quickbooks-settings').trigger('click');
            } else if (window.location.search.includes('quickbooks-sync-historie')) {
                $('.section.quickbooks-sync-histories').trigger('click');
            }
        }
    },

    initSaveButton() {
        $('#qb_settings_save_button').on('click', function() {
            if ($('#quickbooks_sync_warning').length > 0 && $('#time_option').val() === "") {
                $('#quickbooks_sync_warning').modal('show');
                return;
            }

            $('#sync_history_button').trigger('click');

            let url = "/quickbooks-integration/" + $("#quickbooks_sync_id").val() + "/update";
            let data = {
                sync_when_paid: $('#sync_when_paid').is(':checked') ? 1 : 0,
                reconcile_payouts: $('#reconcile_payouts').is(':checked') ? 1 : 0,
                last_sync_date: $('#last_sync').val(),
                time_option: $('#time_option').val(),
            };

            $.ajax({
                url: url,
                type: "POST",
                data: data,
                success: function (response) {
                    location.reload();
                },
                error: function() {
                    $('#qb_something_wrong').modal('show');
                }
            });
        });
    },


    initDisconnectButton() {
        $('#quickbooks_disconnect_button').on('click', function() {
            $(this).prop('disabled', true);

            let url = "/quickbooks-integration/" + $("#quickbooks_sync_id").val() + "/disconnect";

            $.ajax({
                url: url,
                type: "POST",
                success: function (response) {
                    location.href='/settings/integrations-list'
                },
                error: function (response) {
                    $(this).prop('disabled', false);
                    $('#quickbooks_disconnect_modal').modal('hide');
                    $('#qb_something_wrong').modal('show');
                },
            });
        });
    },

    initHelpIcons() {
        $('.help-button-qb').on('click', function(e) {
            if ($(this).hasClass('opened')) {
                $(this).removeClass('opened');

                let class_name = $(this).data('class');
                $(`.help-modal-window.${class_name}`).hide();
            } else {
                $(this).addClass('opened');

                let class_name = $(this).data('class');
                $(`.help-modal-window.${class_name}`).show();

                let posX = $(this).offset().left;
                if ($(".navbar-vertical-left").hasClass('opened')) posX -= 130;

                let posY = $(this).offset().top - $(`.help-modal-window.${class_name}`).height() - 85;

                $(`.help-modal-window.${class_name}`).css({left: posX, top: posY});
            }
        });

        $(document).on('click', function(event) {
            if (!$(event.target).closest('.sync-when-paid-quickbooks, .reconcile-quickbooks, .help-button-qb').length) {
                $('.sync-when-paid-quickbooks, .reconcile-quickbooks').css('display', 'none');
                $('.help-button-qb').removeClass('opened');
            }
        });
    },

    initShowErrors() {
        let $this = this;

        $('body').on('click', '.quickbooks-error-button', function() {
            const $errorModal = $('#quickbooks_errors_modal');

            $errorModal.find('#try_again_quickbooks_button').addClass('d-none');
            $errorModal.find('#user_permission_quickbooks_button').addClass('d-none');
            $errorModal.find('#quickbooks_ticket_button').addClass('d-none');
            $errorModal.find('#quickbooks_ticket_sub').addClass('d-none');
            $errorModal.find('#quickbooks_error_block').addClass('d-none').removeClass('d-flex');
            $errorModal.find('#quickbooks_error_status_message').html('');
            $errorModal.find('#try_again_quickbooks_button button')
                .prop('disabled', false)
                .removeClass('disabled');

            let title = $(this).data('title');
            let errorMessage = $(this).data('errors');
            let buttonPermissions = $(this).data('buttons');

            if (buttonPermissions['confirm']) {
                $errorModal.find('#user_permission_quickbooks_button').removeClass('d-none');
            }
            if (buttonPermissions['try_again'] && $(this).data('user_sync_count') < 2)
                $errorModal.find('#try_again_quickbooks_button').removeClass('d-none');
            if (buttonPermissions['ticket_sub'] && $(this).data('user_sync_count') < 2)
                $errorModal.find('#quickbooks_ticket_sub').removeClass('d-none');
            if (
                buttonPermissions['ticket']
                || (buttonPermissions['try_again'] && $(this).data('user_sync_count') >= 2)
            ) {
                $errorModal.find('#quickbooks_ticket_button').removeClass('d-none');
            }

            $errorModal.find('#quickbooks_errors_block').html(errorMessage);
            $errorModal.find('#quickbooks_sync_object_id').val($(this).data('sync_object_id'));
            $errorModal.find('.modal-header > .modal-custom-title').first().text(title);
            $errorModal.data('error_button_link', $(this));
            $errorModal.modal('show');
        });

        $('body').on('click', '#quickbooks_ticket_button, #quickbooks_ticket_sub a', function() {
            let sync_object_id = $('#quickbooks_errors_modal')
                .find('#quickbooks_sync_object_id')
                .val();

            $('#quickbooks_errors_modal').modal('hide');

            if (sync_object_id) {
                // Автоматически делаем ресинк перед отправкой тикета
                $.ajax({
                    url: '/quickbooks-integration/resync',
                    type: 'POST',
                    data: {
                        sync_object_id: sync_object_id,
                        force: true // Принудительная синхронизация при отправке тикета
                    },
                    success: () => {
                        // После ресинка получаем данные о sync object для тикета
                        $.ajax({
                            url: '/quickbooks-integration/sync-object-for-ticket',
                            method: 'GET',
                            data: {
                                sync_object_id: sync_object_id
                            },
                            success: (response) => {
                                if (response.status) {
                                    // Импортируем HelpTicket динамически
                                    import('../CRUDs/entities/HelpTicket.js').then((module) => {
                                        const HelpTicket = module.default;
                                        const helpTicket = new HelpTicket();

                                        // Формируем subject и details
                                        const subject = 'Errors With QuickBooks';
                                        let details = `${response.type} ID: ${response.org_local_id || 'N/A'}`;

                                        if (response.error_details) {
                                            details += `\n\nError details:\n${response.error_details}`;
                                        }

                                        // Открываем модалку и предустанавливаем значения
                                        helpTicket.openModal('create');

                                        // Ждем, пока форма загрузится, затем заполняем
                                        // Используем проверку наличия формы для более надежной загрузки
                                        const fillForm = () => {
                                            if ($('#create-help_ticket-modal').length && $('#subjectTicket').length) {
                                                helpTicket.autocompleteForm(subject, details);
                                            } else {
                                                setTimeout(fillForm, 100);
                                            }
                                        };

                                        setTimeout(fillForm, 300);
                                    });
                                } else {
                                    // Если не удалось получить данные, просто открываем форму
                                    $('#open_help_ticket_form').trigger('click');
                                }
                            },
                            error: () => {
                                // В случае ошибки просто открываем форму
                                $('#open_help_ticket_form').trigger('click');
                            }
                        });
                    },
                    error: () => {
                        // Если ресинк не удался, все равно открываем форму тикета
                        $.ajax({
                            url: '/quickbooks-integration/sync-object-for-ticket',
                            method: 'GET',
                            data: {
                                sync_object_id: sync_object_id
                            },
                            success: (response) => {
                                if (response.status) {
                                    import('../CRUDs/entities/HelpTicket.js').then((module) => {
                                        const HelpTicket = module.default;
                                        const helpTicket = new HelpTicket();
                                        const subject = 'Errors With QuickBooks';
                                        let details = `${response.type} ID: ${response.org_local_id || 'N/A'}`;
                                        if (response.error_details) {
                                            details += `\n\nError details:\n${response.error_details}`;
                                        }
                                        helpTicket.openModal('create');
                                        const fillForm = () => {
                                            if ($('#create-help_ticket-modal').length && $('#subjectTicket').length) {
                                                helpTicket.autocompleteForm(subject, details);
                                            } else {
                                                setTimeout(fillForm, 100);
                                            }
                                        };
                                        setTimeout(fillForm, 300);
                                    });
                                } else {
                                    $('#open_help_ticket_form').trigger('click');
                                }
                            },
                            error: () => {
                                $('#open_help_ticket_form').trigger('click');
                            }
                        });
                    }
                });
            } else {
                // Если нет sync_object_id, просто открываем форму
                $('#open_help_ticket_form').trigger('click');
            }
        });

        $('body').on(
            'click',
            '#try_again_quickbooks_button button, #user_permission_quickbooks_button button',
            function()
            {
            let clickedButton = $(this);
            const $errorModal = $('#quickbooks_errors_modal');
            clickedButton.addClass('disabled').prop('disabled', true);

            $errorModal.find('#quickbooks_error_block').addClass('d-none').removeClass('d-flex');
            $errorModal.find('#quickbooks_error_status_message').html('');

            $.ajax({
                url: "/quickbooks-integration/resync",
                type: "POST",
                data: {
                    sync_object_id: $errorModal.find('#quickbooks_sync_object_id').val(),
                },
                success: function(response) {
                    if (response.status) {
                        $errorModal.modal('hide');
                        $('#success-action-modal').modal('show');
                    } else {
                        $errorModal.find('#quickbooks_error_block').removeClass('d-none').addClass('d-flex');
                        $errorModal.find('#quickbooks_error_status_message')
                            .html(response.message || "QuickBooks fix failed with an error.");
                        if (response.error) {
                            $errorModal.find('#quickbooks_errors_block').html(response.error);
                        }
                        $errorModal.data('response-status', false);
                        $errorModal
                            .data('error_button_link')
                            .data('user_sync_count', response.user_sync_count);

                        if (response.user_sync_count < 2) {
                            clickedButton.prop('disabled', false).removeClass('disabled');
                        }
                    }
                },
                error: function(response) {
                    if (response.responseJSON.token_fail) {
                        window.location.href = "/settings/integrations-list";
                    } else {
                        $errorModal.modal('hide');
                        $('#qb_something_wrong').modal('show');
                    }
                }
            });
        });

        $('body').on('click', '#quickbooks_errors_modal .close', function() {
            if ($('#quickbooks_errors_modal').data('response-status') === true) {
                location.reload();
            }
        });
    },

    initManualSyncRange() {
        let $this = this;

        $('#quickbooks_manual_sync_button').on('click', function() {
            const $button = $(this);
            const $status = $('#quickbooks_manual_sync_status');
            const start = $('#quickbooks_sync_start_date').val();
            const end = $('#quickbooks_sync_end_date').val();
            const startTime = Date.parse(start + 'T00:00:00Z');
            const endTime = Date.parse(end + 'T00:00:00Z');
            $status.removeClass('d-none alert-info alert-danger alert-success');
            if (!start || !end || !Number.isFinite(startTime) || !Number.isFinite(endTime) || endTime < startTime) {
                $status.addClass('alert-danger').text('Choose a valid start and end date.');
                return;
            }

            $button.prop('disabled', true);
            $status.addClass('alert-info').text('Queueing the background sync…');

            $.ajax({
                url: $button.data('url'),
                type: 'POST',
                data: {
                    option: 'custom',
                    start_date: start,
                    end_date: end,
                },
                success: function(response) {
                    const progress = response.completed_units + '/' + response.total_units;
                    $status
                        .removeClass('alert-info alert-danger')
                        .addClass('alert-success')
                        .text((response.lane_label || 'QuickBooks') + ' run ' + response.run_id + ' queued (' + progress + ' units complete).');
                    $('#sync_message_block').removeClass('d-none');
                    $('#sync_in_progress').val(1);
                    $this.startSyncChecker();
                },
                error: function(response) {
                    const errors = response.responseJSON && response.responseJSON.errors
                        ? Object.values(response.responseJSON.errors).flat()
                        : [];
                    const message = errors[0]
                        || (response.responseJSON && response.responseJSON.message)
                        || 'The QuickBooks sync could not be queued.';
                    $status
                        .removeClass('alert-info alert-success')
                        .addClass('alert-danger')
                        .text(message);
                },
                complete: function() {
                    $button.prop('disabled', false);
                },
            });
        });
    },

    initStartFullSync() {
        let $this = this;

        if ($('#sync_in_progress').val() == 1) {
            $this.updateTableHeightForLoad();
            $('.loader-wrapper').removeClass('d-none').addClass('d-block').css('display', 'block');
            $this.startSyncChecker();
        } else {
            let tenDays = 10 * 24 * 60 * 60 * 1000;
            let timeSinceLastSync = null;
            let lastSyncTime = $('#last_sync').val();
            let datetimeNow = $('#datetime_now').val();

            if ($('#last_sync').val() !== "") {
                timeSinceLastSync = new Date(datetimeNow).getTime() - new Date(lastSyncTime).getTime();
            }

            if ($('#need_sync').val() === '1' && timeSinceLastSync > tenDays) {
                $('#quickbooks_sync_warning').modal('show');
            } else if ($('#need_sync').val() === '1') {
                $this.startFullSync("10_days");
            }
        }

        $('#quickbooks_sync_warning_buttons button').on('click', function() {
            if ($('#need_sync').val() === '1') {
                $this.startFullSync($(this).data('option'));
            } else {
                $('#time_option').val($(this).data('option'));
                $('#qb_settings_save_button').trigger('click');
            }

            $('#quickbooks_sync_warning').modal('hide');
        });
    },

    startFullSync(option) {
        let $this = this;

        $this.updateTableHeightForLoad();
        $('.loader-wrapper').removeClass('d-none').addClass('d-block').css('display', 'block');
        $('#sync_message_block').removeClass('d-none');
        $('#sync_in_progress').val(1);

        let url = "/quickbooks-integration/" + $("#quickbooks_sync_id").val() + "/full-sync";

        $.ajax({
            url: url,
            type: "POST",
            data: {
                option: option,
            },
            success: function() {
                $this.startSyncChecker();
            }
        });
    },

    startSyncChecker() {
        if (this.syncCheckerInterval !== null) {
            return;
        }

        this.syncCheckerInterval = setInterval(() => {
            let url = "/quickbooks-integration/" + $("#quickbooks_sync_id").val() + "/check-sync-in-progress";

            $.ajax({
                url: url,
                type: "GET",
                success: function(response) {
                    if (response.message) {
                        clearInterval(this.syncCheckerInterval);
                        this.syncCheckerInterval = null;
                        location.reload();
                    }
                }.bind(this),
            });
        }, 30000);
    },

    initReloadPreloader() {
        let $this = this;

        if ($('#need_sync').val() === '1' || $('#sync_in_progress').val() === '1') {
            let interval = setInterval(() => {
                if ($('.loader-wrapper').hasClass('d-none')) {
                    $this.updateTableHeightForLoad();
                    $('.loader-wrapper').removeClass('d-none').addClass('d-block').css('display', 'block');
                    clearInterval(interval);
                }
            }, 1);
        }
    },

    initSettingClicksChecker() {
        $('#sync_when_paid, #reconcile_payouts').on('click', function() {
            let syncWhenPaidOldStatus = Boolean($('#sync_when_paid').data('old_status'));
            let syncWhenPaidCurrentStatus = $('#sync_when_paid').is(':checked');
            let reconcilePayoutsOldStatus = Boolean($('#reconcile_payouts').data('old_status'));
            let reconcilePayoutsCurrentStatus = $('#reconcile_payouts').is(':checked');

            if (
                syncWhenPaidOldStatus === syncWhenPaidCurrentStatus
                && reconcilePayoutsOldStatus === reconcilePayoutsCurrentStatus
            ) {
                $('#qb_settings_save_button').prop('disabled', true).addClass('disabled');
            } else {
                $('#qb_settings_save_button').prop('disabled', false).removeClass('disabled');
            }
        });
    },

    initContactUpButton() {
        $('#show_help_model_from_qb_button').on('click', function() {
            $('#quickbooks_sync_warning').modal('hide');
            $("a[data-target='#help-modal']").trigger('click');
        });
    },

    updateTableHeightForLoad() {
        let documentHeight = $(document).height();
        let windowHeight = $(window).height();
        let tableHeight = $('.stafter-table-wrapper').height();
        let loadHeight = tableHeight - (documentHeight - windowHeight);
        $('#data-tables').css({
            'max-height': loadHeight,
            'height': loadHeight,
        });
        $('.data-view.quickbooks-sync-histories').css({
            'max-height': loadHeight,
            'height': loadHeight,
        });
        $('.loader-wrapper').css({
            'max-height': loadHeight,
            'height': loadHeight,
        });
        $('.stafter-table-wrapper').css({
            'max-height': loadHeight,
            'height': loadHeight,
        });
    },
}
